import ActionTypes from '../constants/ActionTypes';
import Events from '../constants/Events';

export const gettingPermissions = () => {
  return { type: ActionTypes.GET_PERMISSIONS };
};

export const retrievedPermissions = permissions => {
  return {
    type: Events.RETRIEVED_PERMISSIONS,
    payload: permissions
  };
};

export const failedToRetrievePermissions = payload => {
  return {
    type: Events.PERMISSIONS_FAILED,
    payload
  };
};
